var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BaseGridCard",
    _vm._g(
      _vm._b(
        { class: ["base-grid-card-vertical", "d-flex flex-column"] },
        "BaseGridCard",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    ),
    [
      _vm._t("body"),
      _vm._v(" "),
      _c("v-spacer"),
      _vm._v(" "),
      _vm._t("footer"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }